import React, { useReducer, useEffect } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import ErrorBoundary from '../ErrorBoundary'
import AddIcon from '@material-ui/icons/Add'
import RemoveIcon from '@material-ui/icons/Remove'
import { IconButton } from '@material-ui/core'

const collapseReducer = (target) => (collapsed, _) => {
  target.style.display = collapsed ? '' : 'none'
  return !collapsed
}

export default function CollapseButton (props) {
  const [collapsed, collapse] = useReducer(
    collapseReducer(props.collapseTarget),
    props.collapsed
  )

  useEffect(() => {
    props.triggerButton.addEventListener('click', () => collapse())
  }, [])

  return (
    <IconButton color='inherit' size='small'>
      {collapsed ? <AddIcon /> : <RemoveIcon />}
    </IconButton>
  )
}

CollapseButton.propTypes = {
  triggerButton: PropTypes.instanceOf(Element),
  collapseTarget: PropTypes.instanceOf(Element),
  collapsed: PropTypes.bool
}

CollapseButton.defaultProps = {
  collapsed: false
}

document.querySelectorAll('.collapse-button').forEach((el) => {
  const triggerButtonId = el.dataset.triggerButtonId
  const triggerButton = document.getElementById(triggerButtonId)
  if (!triggerButton) {
    console.error('collapse-buttonクラスの要素にはtrigger-button-id属性を設定してください。')
  }

  const collapsed = el.dataset.collapsed !== 'false'

  const collapseTargetId = el.dataset.targetId
  const collapseTarget = document.getElementById(collapseTargetId)
  if (collapseTarget) {
    collapseTarget.style.display = collapsed ? 'none' : ''
  } else {
    console.error('collapse-buttonクラスの要素にはdata-target-id属性を設定してください。')
  }

  ReactDOM.render(
    <ErrorBoundary>
      <CollapseButton triggerButton={triggerButton} collapseTarget={collapseTarget} collapsed={collapsed} />
    </ErrorBoundary>,
    el
  )
})
